import Logo from "./Logo"
import { Link } from "react-router-dom"

function Header() {
  return (
    <div className="header-container ">
      <Logo />
      <div className="header-links-wrapper">
        <a href='#solutions' className="header-link">Our Solutions</a>
        <a href='#cases'  className="header-link">Use Cases</a>
        <a href='#pricing'  className="header-link">Pricing</a>
      </div>
      <div className="header-entry">
        <Link to='/login' className="header-signin-link">Sign In</Link>
        <Link to='/signup' className="header-signup-btn">Sign Up</Link>
      </div>
      </div>
  )
}

export default Header